<ng-container *ngIf="mode === 'menu'">
	<ul
		class="floating-action-menu"
		[ngClass]="{ active: open, dark_theme: darkTheme }"
		(stagesClickOutside)="closeHandler()"
	>
		<li>
			<button
				[disabled]="isButtonDisabled || isLoading"
				[type]="'button'"
				[attr.title]="buttonTitle | translate"
				[attr.aria-label]="buttonTitle | translate"
				class="action main"
				[ngClass]="customButtonClasses"
				(click)="toggleMenu()"
			>
				<i *ngIf="!isLoading" [class]="open ? closeIcon : iconClass" [style.font-size]="iconSize"></i>
				<stages-spin *ngIf="isLoading"></stages-spin>
			</button>
		</li>
		<ul class="related-actions" [ngClass]="{ active: open }">
			<ng-container *ngFor="let menuItem of menuItems; index as index; trackBy: trackByIndex">
				<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
				<li [style.transition-delay]="getTransitionDelay(index)">
					<button
						type="button"
						class="needsclick action"
						[ngClass]="menuItem.buttonCssClass ? menuItem.buttonCssClass : customButtonClasses"
						[attr.title]="menuItem.messageKey | translate"
						[attr.aria-label]="menuItem.messageKey | translate"
						(click)="menuItem.on(menuItem.subtypeItem)"
					>
						<i class="ico" [ngClass]="menuItem.iconClass"></i>
						<span class="bubble">{{ !menuItem.messageKey ? menuItem.name : (menuItem.messageKey | translate) }}</span>
					</button>
				</li>
			</ng-container>
		</ul>
	</ul>
</ng-container>

<button
	*ngIf="mode === 'button' && menuItems.length === 1"
	type="button"
	class="floating-action needsclick"
	(click)="menuItems[0].on(menuItems[0].subtypeItem)"
>
	<i class="ico ico-add"></i>
</button>
